import { applyMiddleware, createStore, StoreEnhancer } from "redux";
import thunk from "redux-thunk";
import APIMiddleware from "./Shared/Middleware/API/API";
import logger from "./Shared/Middleware/Logger/Logger";
import reducer from "./Reducers";
import { composeWithDevTools } from "redux-devtools-extension";
import performanceReducerEnhancer from "./Shared/Enhancers/Performance/Performance";

const configureStore = (_preloadedState: any) => {
    const middlewares: any = [logger, APIMiddleware, thunk];
    const middlewareEnhancer = applyMiddleware(...middlewares);

    const enhancers: any = [middlewareEnhancer, performanceReducerEnhancer];
    const composedEnhancers: StoreEnhancer = composeWithDevTools(...enhancers);

    return createStore(reducer, _preloadedState, composedEnhancers);
}

export default configureStore;